import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import _ from 'lodash';
import { useAuth } from '../../hooks/useAuth';
import { toast } from 'react-toastify';
const TripsDetails = () => {
    const [data, setData] = useState();
    const [unitConfig, setUnitConfig] = useState({});
    const navigate = useNavigate();
    const { getToken } = useAuth();
    const { state } = useLocation();

    useEffect(() => {
        if (state?.trip_id) {
            getUnitConfig();
            getTripDetails(state?.trip_id);
        }
    }, []);
    const getUnitConfig = async () => {
        const token = getToken();
        new WebApiCalls()
            .getRewardSettings(token)
            .then((res) => {
                setUnitConfig(res.data);
            })
            .catch((err) => {
                toast.error('Something went wrong while fetching units');
            });
    };
    const getTripDetails = async (id = '') => {
        const token = getToken();
        if (id && token) {
            new WebApiCalls()
                .tripDetials(token, id)
                .then((res) => {
                    if (res?.code === 200) {
                        setData(res?.data);
                    }
                })
                .catch((err) => {
                    console.log('Error in TRip details:   ', err);
                });
        }
    };
    const handleBackClick = () => {
        navigate(-1);
    };
    return (
        <>
            <Row className="justify-content-end align-items-center">
                <Col sm={4} md={3} className="text-end">
                    <Button onClick={handleBackClick} className="theme-cancel-btn px-5 py-2">
                        Close
                    </Button>
                </Col>
            </Row>
            {/* <Row>
                <Col sm={4}>
                    <div className="detail-heading ms-5">Agency Details</div>
                </Col>
            </Row> */}
            <Row className="d-flex justify-content-center">
                <Col xs={12} sm={12} md={11} lg={11} className="p-4 m-3 ">
                    <Row>
                        <Col sm={6} md={2} className="mb-4">
                            <div className="detail-small-heading">Agency Name</div>
                            <div className="detail-value">{data?.transit_agency?.name}</div>
                        </Col>

                        <Col sm={6} md={2} className="mb-4">
                            <div className="detail-small-heading">Commuter Name</div>
                            <div className="detail-value">{data?.commuter?.name}</div>
                        </Col>

                        <Col sm={6} md={2} className="mb-4">
                            <div className="detail-small-headingg">Transit Type</div>
                            <div className="detail-value">{data?.transit_type}</div>
                        </Col>

                        <Col sm={6} md={2} className="mb-4">
                            <div className="detail-small-heading">Starting Station</div>
                            <div className="detail-value">{data?.starting_station?.name}</div>
                        </Col>

                        <Col sm={6} md={2} className="mb-4">
                            <div className="detail-small-heading">Ending Station</div>
                            <div className="detail-value">{data?.last_station?.name}</div>
                        </Col>

                        <Col sm={6} md={2} className="mb-4">
                            <div className="detail-small-heading">Status</div>
                            <div className="detail-value">{data?.status}</div>
                        </Col>

                        <Col sm={6} md={2} className="mb-4">
                            <div className="detail-small-heading">Average Speed</div>
                            <div className="detail-value">
                                {data?.average_speed || 0}
                                {data?.average_speed ? unitConfig.distanceUnit : null}
                            </div>
                        </Col>
                        <Col sm={6} md={2} className="mb-4">
                            <div className="detail-small-heading">Distance</div>
                            <div className="detail-value">
                                {data?.distance || 0}
                                {data?.distance ? unitConfig.distanceUnit : null}
                            </div>
                        </Col>
                        <Col sm={6} md={2} className="mb-4">
                            <div className="detail-small-heading">GHG Saved</div>
                            <div className="detail-value">
                                {data?.ghg_saved || 0}
                                {data?.ghg_saved ? unitConfig.ghgUnit : null}
                            </div>
                        </Col>

                        <Col sm={6} md={4} className="mb-4">
                            <div className="detail-small-heading">Points Earned</div>
                            <div className="detail-value">{data?.points_earned}</div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );
};

export default TripsDetails;
